import {
	Component,
	Input,
	Output,
	EventEmitter,
	OnChanges,
	SimpleChanges,
} from '@angular/core';
import { User } from '@lmc-app/shared/interface/user.interface';

@Component({
	selector: 'app-activities',
	templateUrl: './activities.component.html',
	styleUrls: ['./activities.component.scss'],
})
export class ActivitiesComponent implements OnChanges {
	@Input() application: any;
	@Input() applicationId: string;
	@Output() applicationChange = new EventEmitter();
	@Input() currentUser: User;

	ngOnChanges(changes: SimpleChanges) {
		this.application = changes.application?.currentValue;
		if (changes.currentUser?.currentValue) {
			this.currentUser = changes.currentUser?.currentValue;
		}
	}
}
